/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Version } from './version';
import { ValidValueRange } from './validValueRange';


export interface DeviceTypeParameterConfigWithAvailableListDto { 
    parameterId: string;
    note?: string;
    minFirmwareVersion?: Version;
    validValueRange?: ValidValueRange;
    defaultValue?: string;
    parsedMax?: string;
    parsedMin?: string;
    parsedList?: Array<string>;
    minPcbTypeId?: string;
    userAccess: DeviceTypeParameterConfigWithAvailableListDto.UserAccessEnum;
    availableForDevices?: Array<number>;
}
export namespace DeviceTypeParameterConfigWithAvailableListDto {
    export const UserAccessEnum = {
        None: 'NONE',
        ReadLocal: 'READ_LOCAL',
        ReadRemote: 'READ_REMOTE',
        WriteLocal: 'WRITE_LOCAL',
        WriteRemote: 'WRITE_REMOTE'
    } as const;
    export type UserAccessEnum = typeof UserAccessEnum[keyof typeof UserAccessEnum];
}


export type UserAccessEnum = typeof DeviceTypeParameterConfigWithAvailableListDto.UserAccessEnum[keyof typeof DeviceTypeParameterConfigWithAvailableListDto.UserAccessEnum];
